import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MicroCredential from "@/components/MicroCredential";
import Workshops from "@/components/Workshops";
import Accreditation from "@/components/Accreditation";
import Team from "@/components/Team";
import CalendarSection from "@/components/CalendarSection";
import InterestForm from "@/components/InterestForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero />
      <MicroCredential />
      <Workshops />
      <Accreditation />
      <Team />
      <CalendarSection />
      <InterestForm />
      <Footer />
    </div>
  );
}
